import { render, staticRenderFns } from "./person-select.vue?vue&type=template&id=d2af7fbc&scoped=true&"
import script from "./person-select.vue?vue&type=script&lang=js&"
export * from "./person-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2af7fbc",
  null
  
)

export default component.exports